<template>
  <div class="page1">
    <div class="landscape" @touchmove.prevent>
      <div class="lcx">
        <img class="phoPic" src="../../static/img/phone.png" alt="" />
        <div class="word">为了更好的体验，请锁定屏幕后浏览</div>
      </div>
    </div>
    <div class="bgm">
      <img class="bgPic" src="../../static/img/page1-bg.jpg" alt="" />
    </div>
    <img class="location1" src="../../static/img/location.png" alt="" />
    <img class="location2" src="../../static/img/location.png" alt="" />
    <img class="location3" src="../../static/img/location.png" alt="" />
    <img class="location4" src="../../static/img/location.png" alt="" />
    <img class="location5" src="../../static/img/location.png" alt="" />
    <img class="location6" src="../../static/img/location.png" alt="" />
    <img class="location7" src="../../static/img/location.png" alt="" />
    <img class="location8" src="../../static/img/location.png" alt="" />
    <img class="location9" src="../../static/img/location.png" alt="" />
    <img class="location10" src="../../static/img/location.png" alt="" />
    <img class="location11" src="../../static/img/location.png" alt="" />
    <img
      @click="gjk"
      class="gjkname"
      src="../../static/img/gjk-name.png"
      alt=""
    />
    <img
      @click="cfdq"
      class="cfdqname"
      src="../../static/img/cfdq-name.png"
      alt=""
    />
    <img
      @click="yqg"
      class="yqgname"
      src="../../static/img/yqg-name.png"
      alt=""
    />
    <img
      @click="spdq"
      class="spdqname"
      src="../../static/img/spdq-name.png"
      alt=""
    />
    <img
      @click="wsjdq"
      class="wsjdqname"
      src="../../static/img/wsjdq-name.png"
      alt=""
    />
    <img
      @click="shj"
      class="shjname"
      src="../../static/img/shj-name.png"
      alt=""
    />
    <img
      @click="stld"
      class="stldname"
      src="../../static/img/stld-name.png"
      alt=""
    />
    <img
      @click="jnsx"
      class="jnsxname"
      src="../../static/img/jnsx-name.png"
      alt=""
    />
    <img
      @click="tcgx"
      class="tcgxname"
      src="../../static/img/tcgx-name.png"
      alt=""
    />
    <img
      @click="szh"
      class="szhname"
      src="../../static/img/szh-name.png"
      alt=""
    />
    <img
      @click="hpjmt"
      class="hpjmtname"
      src="../../static/img/hpjmt-name.png"
      alt=""
    />

    <img class="theme" src="../../static/img/theme.png" alt="" />
    <img class="intro" src="../../static/img/intro.png" alt="" />
    <img class="begin" src="../../static/img/begin.png" alt="" />
    <img class="screen1" src="../../static/img/screen1.png" alt="" />
    <img class="screen2" src="../../static/img/screen2.png" alt="" />

    <img
      @click="togjk"
      v-show="boat0"
      class="boat0"
      src="static/img/boat.png"
      alt=""
    />
    <img
      @click="tocfdq"
      v-show="boat1"
      class="boat1"
      src="static/img/boat.png"
      alt=""
    />
    <img
      @click="toyqg"
      v-show="boat2"
      class="boat2"
      src="static/img/boat.png"
      alt=""
    />
    <img
      @click="tospdq"
      v-show="boat3"
      class="boat3"
      src="static/img/boat.png"
      alt=""
    />
    <img
      @click="towsjdq"
      v-show="boat4"
      class="boat4"
      src="static/img/boat.png"
      alt=""
    />
    <img
      @click="toshj"
      v-show="boat5"
      class="boat5"
      src="static/img/boat.png"
      alt=""
    />
    <img
      @click="tostld"
      v-show="boat6"
      class="boat6"
      src="static/img/boat.png"
      alt=""
    />
    <img
      @click="tojnsx"
      v-show="boat7"
      class="boat7"
      src="static/img/boat.png"
      alt=""
    />
    <img
      @click="totcgx"
      v-show="boat8"
      class="boat8"
      src="static/img/boat.png"
      alt=""
    />
    <img
      @click="toszh"
      v-show="boat9"
      class="boat9"
      src="static/img/boat.png"
      alt=""
    />
    <img
      @click="tohpjmt"
      v-show="boat10"
      class="boat10"
      src="static/img/boat.png"
      alt=""
    />

    <img v-show="boat11" class="boat11" src="static/img/boat.png" alt="" />

    <img class="cover1" src="static/img/cover1.png" alt="" />
    <img class="cover2" src="static/img/cover2.png" alt="" />
    <img class="cover3" src="static/img/cover3.png" alt="" />
    <img class="cover4" src="static/img/cover4.png" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      boat0: this.$store.state.isBoat[0],
      boat1: this.$store.state.isBoat[1],
      boat2: this.$store.state.isBoat[2],
      boat3: this.$store.state.isBoat[3],
      boat4: this.$store.state.isBoat[4],
      boat5: this.$store.state.isBoat[5],
      boat6: this.$store.state.isBoat[6],
      boat7: this.$store.state.isBoat[7],
      boat8: this.$store.state.isBoat[8],
      boat9: this.$store.state.isBoat[9],
      boat10: this.$store.state.isBoat[10],
      boat11: this.$store.state.isBoat[11],
      // begain:0
    };
  },
  methods: {
    gjk() {
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.$store.commit("handleScrollTop", scrollt);
      this.$router.push("/page2");
    },
    cfdq() {
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.$store.commit("handleScrollTop", scrollt);
      this.$router.push("/page3");
    },
    yqg() {
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.$store.commit("handleScrollTop", scrollt);
      this.$router.push("/page12");
    },
    spdq() {
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.$store.commit("handleScrollTop", scrollt);
      this.$router.push("/page7");
    },
    wsjdq() {
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.$store.commit("handleScrollTop", scrollt);
      this.$router.push("/page11");
    },
    shj() {
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.$store.commit("handleScrollTop", scrollt);
      this.$router.push("/page8");
    },
    stld() {
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.$store.commit("handleScrollTop", scrollt);
      this.$router.push("/page6");
    },
    jnsx() {
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.$store.commit("handleScrollTop", scrollt);
      this.$router.push("/page5");
    },
    tcgx() {
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.$store.commit("handleScrollTop", scrollt);
      this.$router.push("/page10");
    },
    szh() {
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.$store.commit("handleScrollTop", scrollt);
      this.$router.push("/page9");
    },
    hpjmt() {
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.$store.commit("handleScrollTop", scrollt);
      this.$router.push("/page4");
    },

    togjk() {
      let boat = document.querySelector(".boat0");
      // console.log(boat.offsetTop)
      let scrollt =
        document.documentElement.scrollTop || document.body.scrollTop;
      // var begin = boat.offsetTop;
      boat.style.animation = "gjk 1s linear 1";
      boat.style.animationFillMode = "forwards";
      this.$store.commit("handleIsBoat", 1);

      for (var i = 0; i <= 200; i++) {
        // console.log(begin)
        (function (j) {
          setTimeout(function () {
            // console.log(begin)
            // console.log(j);
            document.body.scrollTop = scrollt + j;
            document.documentElement.scrollTop = scrollt + j;
          }, j * 10);
        })(i);
      }

      let that = this;
      setTimeout(function () {
        let boat = document.querySelector(".boat0");
        that.$store.commit("handleScrollTop", boat.offsetTop);
        // console.log(begin, boat.offsetTop);
        that.$router.push("/page2");
      }, 1500);
    },
    tocfdq() {
      if (this.$store.state.isBoat[1] == true) {
        let scrollt =
          document.documentElement.scrollTop || document.body.scrollTop;
        // this.$store.commit("handleScrollTop", scrollt);
        let boat = document.querySelector(".boat1");
        boat.style.animation = "cfdq 0.8s linear 1";
        boat.style.animationFillMode = "forwards";
        this.$store.commit("handleIsBoat", 2);

        for (var i = 0; i <= 200; i++) {
          (function (j) {
            setTimeout(function () {
              document.body.scrollTop = scrollt + j;
              document.documentElement.scrollTop = scrollt + j;
            }, j * 10);
          })(i);
        }

        let that = this;
        setTimeout(function () {
          let boat = document.querySelector(".boat1");
          that.$store.commit("handleScrollTop", boat.offsetTop);
          that.$router.push("/page3");
        }, 1300);
      }
    },
    toyqg() {
      if (this.$store.state.isBoat[2] == true) {
        let scrollt =
          document.documentElement.scrollTop || document.body.scrollTop;
        // this.$store.commit("handleScrollTop", scrollt);
        let boat = document.querySelector(".boat2");
        boat.style.animation = "yqg 3s linear 1";
        boat.style.animationFillMode = "forwards";
        this.$store.commit("handleIsBoat", 3);

        for (var i = 0; i <= 250; i++) {
          (function (j) {
            setTimeout(function () {
              document.body.scrollTop = scrollt + j;
              document.documentElement.scrollTop = scrollt + j;
            }, j * 10);
          })(i);
        }

        let that = this;
        setTimeout(function () {
          let boat = document.querySelector(".boat2");
          that.$store.commit("handleScrollTop", boat.offsetTop);
          that.$router.push("/page12");
        }, 3500);
      }
    },
    tospdq() {
      if (this.$store.state.isBoat[3] == true) {
        let scrollt =
          document.documentElement.scrollTop || document.body.scrollTop;
        // this.$store.commit("handleScrollTop", scrollt);
        let boat = document.querySelector(".boat3");
        boat.style.animation = "spdq 2s linear 1";
        boat.style.animationFillMode = "forwards";
        this.$store.commit("handleIsBoat", 4);

        for (var i = 0; i <= 200; i++) {
          (function (j) {
            setTimeout(function () {
              document.body.scrollTop = scrollt + j;
              document.documentElement.scrollTop = scrollt + j;
            }, j * 10);
          })(i);
        }

        let that = this;
        setTimeout(function () {
          let boat = document.querySelector(".boat3");
          that.$store.commit("handleScrollTop", boat.offsetTop);
          that.$router.push("/page7");
        }, 2500);
      }
    },
    towsjdq() {
      if (this.$store.state.isBoat[4] == true) {
        let scrollt =
          document.documentElement.scrollTop || document.body.scrollTop;
        // this.$store.commit("handleScrollTop", scrollt);
        let boat = document.querySelector(".boat4");
        boat.style.animation = "wsjdq 4s linear 1";
        boat.style.animationFillMode = "forwards";
        this.$store.commit("handleIsBoat", 5);

        for (var i = 0; i <= 350; i++) {
          (function (j) {
            setTimeout(function () {
              document.body.scrollTop = scrollt + j;
              document.documentElement.scrollTop = scrollt + j;
            }, j * 10);
          })(i);
        }

        let that = this;
        setTimeout(function () {
          let boat = document.querySelector(".boat4");
          that.$store.commit("handleScrollTop", boat.offsetTop);
          that.$router.push("/page11");
        }, 4500);
      }
    },
    toshj() {
      if (this.$store.state.isBoat[5] == true) {
        let scrollt =
          document.documentElement.scrollTop || document.body.scrollTop;
        // this.$store.commit("handleScrollTop", scrollt);
        let boat = document.querySelector(".boat5");
        boat.style.animation = "shj 2s linear 1";
        boat.style.animationFillMode = "forwards";
        this.$store.commit("handleIsBoat", 6);

        for (var i = 0; i <= 200; i++) {
          (function (j) {
            setTimeout(function () {
              document.body.scrollTop = scrollt + j;
              document.documentElement.scrollTop = scrollt + j;
            }, j * 10);
          })(i);
        }

        let that = this;
        setTimeout(function () {
          let boat = document.querySelector(".boat5");
          that.$store.commit("handleScrollTop", boat.offsetTop);
          that.$router.push("/page8");
        }, 2500);
      }
    },
    tostld() {
      if (this.$store.state.isBoat[6] == true) {
        let scrollt =
          document.documentElement.scrollTop || document.body.scrollTop;
        // this.$store.commit("handleScrollTop", scrollt);
        let boat = document.querySelector(".boat6");
        boat.style.animation = "stld 2s linear 1";
        boat.style.animationFillMode = "forwards";
        this.$store.commit("handleIsBoat", 7);

        for (var i = 0; i <= 200; i++) {
          (function (j) {
            setTimeout(function () {
              document.body.scrollTop = scrollt + j;
              document.documentElement.scrollTop = scrollt + j;
            }, j * 10);
          })(i);
        }

        let that = this;
        setTimeout(function () {
          let boat = document.querySelector(".boat6");
          that.$store.commit("handleScrollTop", boat.offsetTop);
          that.$router.push("/page6");
        }, 2500);
      }
    },
    tojnsx() {
      if (this.$store.state.isBoat[7] == true) {
        let scrollt =
          document.documentElement.scrollTop || document.body.scrollTop;
        // this.$store.commit("handleScrollTop", scrollt);
        let boat = document.querySelector(".boat7");
        boat.style.animation = "jnsx 2s linear 1";
        boat.style.animationFillMode = "forwards";
        // this.$router.push("/page5")
        this.$store.commit("handleIsBoat", 8);
        for (var i = 0; i <= 200; i++) {
          (function (j) {
            setTimeout(function () {
              document.body.scrollTop = scrollt + j;
              document.documentElement.scrollTop = scrollt + j;
            }, j * 10);
          })(i);
        }
        let that = this;
        setTimeout(function () {
          let boat = document.querySelector(".boat7");
          that.$store.commit("handleScrollTop", boat.offsetTop);
          that.$router.push("/page5");
        }, 2500);
      }
    },
    totcgx() {
      if (this.$store.state.isBoat[8] == true) {
        let scrollt =
          document.documentElement.scrollTop || document.body.scrollTop;
        // this.$store.commit("handleScrollTop", scrollt);
        let boat = document.querySelector(".boat8");
        boat.style.animation = "tcgx 3s linear 1";
        boat.style.animationFillMode = "forwards";
        // this.$router.push("/page10")
        this.$store.commit("handleIsBoat", 9);

        for (var i = 0; i <= 200; i++) {
          (function (j) {
            setTimeout(function () {
              document.body.scrollTop = scrollt + j;
              document.documentElement.scrollTop = scrollt + j;
            }, j * 10);
          })(i);
        }
        let that = this;
        setTimeout(function () {
          let boat = document.querySelector(".boat8");
          that.$store.commit("handleScrollTop", boat.offsetTop);
          that.$router.push("/page10");
        }, 3500);
      }
    },
    toszh() {
      if (this.$store.state.isBoat[9] == true) {
        let scrollt =
          document.documentElement.scrollTop || document.body.scrollTop;
        // this.$store.commit("handleScrollTop", scrollt);
        let boat = document.querySelector(".boat9");
        boat.style.animation = "szh 2s linear 1";
        boat.style.animationFillMode = "forwards";
        // this.$router.push("/page9")
        this.$store.commit("handleIsBoat", 10);
        let that = this;
        setTimeout(function () {
          let boat = document.querySelector(".boat9");
          that.$store.commit("handleScrollTop", boat.offsetTop);
          that.$router.push("/page9");
        }, 2500);
      }
    },
    tohpjmt() {
      if (this.$store.state.isBoat[10] == true) {
        let scrollt =
          document.documentElement.scrollTop || document.body.scrollTop;
        // this.$store.commit("handleScrollTop", scrollt);
        let boat = document.querySelector(".boat10");
        boat.style.animation = "hpjmt 2s linear 1";
        boat.style.animationFillMode = "forwards";
        this.$store.commit("handleIsBoat", 11);
        let that = this;
        setTimeout(function () {
          let boat = document.querySelector(".boat10");
          that.$store.commit("handleScrollTop", boat.offsetTop);
          that.$router.push("/page4");
        }, 2500);
      }
    },
  },
  mounted() {
    let that = this;
    setTimeout(function () {
      document.body.scrollTop = that.$store.state.ScrollTop;
      document.documentElement.scrollTop = that.$store.state.ScrollTop;
      window.pageYOffset = that.$store.state.ScrollTop;
      window.scrollY = that.$store.state.ScrollTop;
      window.scrollTo = that.$store.state.ScrollTop;
      window.offsetTop = that.$store.state.ScrollTop;
    }, 100);
    var screenDirection = window.matchMedia("(orientation: portrait)");
    screenDirection.addListener(handleOrientationChange);
    handleOrientationChange(screenDirection);
    function handleOrientationChange(screenDirection) {
      if (screenDirection.matches) {
        console.log("竖屏");
      } else {
        console.log("横屏");
        let landscape = document.querySelector(".landscape");
        let landscapeH =
          document.documentElement.scrollTop || document.body.scrollTop;
        landscape.style.top = landscapeH + "px";
      }
    }

    const ua = navigator.userAgent.toLowerCase();
    const isIOS = ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i);
    // console.log(isIOS);
    if (isIOS) {
      const ios_var = ua.match(/cpu iphone os (.*?) like mac os/);
      // alert(Number(ios_var[1].replace(/_.+$/g, '')))
      console.log(Number(ios_var[1].replace(/_.+$/g, '')));
      if (Number(ios_var[1].replace(/_.+$/g, "")) <= 14) {
        let that = this;
        setTimeout(function () {
          document.body.scrollTop = that.$store.state.ScrollTop;
          document.documentElement.scrollTop = that.$store.state.ScrollTop;
          window.pageYOffset = that.$store.state.ScrollTop;
          window.scrollY = that.$store.state.ScrollTop;
          window.scrollTo = that.$store.state.ScrollTop;
          window.offsetTop = that.$store.state.ScrollTop;
        }, 250);
      }
    }
  },
};
</script>

<style>
.all {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.page1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  /* height:100vh; */
  overflow: hidden;
  /* z-index:800 */
}
.page1 .bgm {
  width: 100vw;
  /* height:100vh; */
  overflow: auto;
}
.page1 .bgm .bgPic {
  width: 100vw;
}
.theme {
  width: 62.27%;
  position: absolute;
  top: 0.4%;
  left: 23%;
  animation: toRight 0.6s linear;
  animation-fill-mode: forwards;
}
.intro {
  width: 46.13%;
  position: absolute;
  top: 8%;
  /* left: 5%; */
  animation: toTop 0.6s linear;
  animation-fill-mode: forwards;
}
.begin {
  width: 9.33%;
  position: absolute;
  top: 15%;
  left: 3%;
  animation: twinkle 2s linear infinite;
}
.screen1 {
  width: 18.8%;
  position: absolute;
  top: 29.47%;
  left: 4.5%;
  animation: twinkle 2s linear infinite;
}
.screen2 {
  width: 17.87%;
  position: absolute;
  top: 79.05%;
  left: 57%;
  animation: twinkle 2s linear infinite;
}

.location1 {
  position: absolute;
  width: 7.3%;
  top: 22%;
  left: 33%;
  animation-name: bounceLogo;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transform-origin: center bottom;
}
.location2 {
  position: absolute;
  width: 7.3%;
  top: 26%;
  left: 49%;
  animation-name: bounceLogo;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transform-origin: center bottom;
}
.location3 {
  position: absolute;
  width: 7.3%;
  top: 34%;
  left: 79%;
  animation-name: bounceLogo;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transform-origin: center bottom;
}
.location4 {
  position: absolute;
  width: 7.3%;
  top: 43%;
  left: 77%;
  animation-name: bounceLogo;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transform-origin: center bottom;
}
.location5 {
  position: absolute;
  width: 7.3%;
  top: 58.9%;
  left: 46%;
  animation-name: bounceLogo;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transform-origin: center bottom;
}
.location6 {
  position: absolute;
  width: 7.3%;
  top: 63.7%;
  left: 20%;
  animation-name: bounceLogo;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transform-origin: center bottom;
}
.location7 {
  position: absolute;
  width: 7.3%;
  top: 69.3%;
  left: 89%;
  animation-name: bounceLogo;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transform-origin: center bottom;
}
.location8 {
  position: absolute;
  width: 7.3%;
  top: 75.7%;
  left: 17%;
  animation-name: bounceLogo;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transform-origin: center bottom;
}
.location9 {
  position: absolute;
  width: 7.3%;
  top: 85.5%;
  left: 84%;
  animation-name: bounceLogo;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transform-origin: center bottom;
}
.location10 {
  position: absolute;
  width: 7.3%;
  top: 88.6%;
  left: 41%;
  animation-name: bounceLogo;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transform-origin: center bottom;
}
.location11 {
  position: absolute;
  width: 7.3%;
  top: 91%;
  left: 81%;
  animation-name: bounceLogo;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transform-origin: center bottom;
}
.gjkname {
  width: 5.3%;
  position: absolute;
  top: 21.8%;
  left: 27.5%;
  animation: isShow 1s linear infinite;
}
.cfdqname {
  width: 21.87%;
  position: absolute;
  top: 25.7%;
  left: 33%;
  animation: isShow 1s linear infinite;
}
.yqgname {
  width: 15.47%;
  position: absolute;
  top: 33%;
  left: 70%;
  animation: isShow 1s linear infinite;
}
.spdqname {
  width: 26%;
  position: absolute;
  top: 42.5%;
  left: 57%;
  animation: isShow 1s linear infinite;
}
.wsjdqname {
  width: 9.73%;
  position: absolute;
  top: 58%;
  left: 36%;
  animation: isShow 1s linear infinite;
}
.shjname {
  width: 7.73%;
  position: absolute;
  top: 63.2%;
  left: 12%;
  animation: isShow 1s linear infinite;
}
.stldname {
  width: 6.4%;
  position: absolute;
  top: 68.5%;
  left: 82%;
  animation: isShow 1s linear infinite;
}
.jnsxname {
  width: 7.47%;
  position: absolute;
  top: 75%;
  left: 9%;
  animation: isShow 1s linear infinite;
}
.tcgxname {
  width: 9.47%;
  position: absolute;
  top: 85%;
  left: 76%;
  animation: isShow 1s linear infinite;
}
.szhname {
  width: 8.53%;
  position: absolute;
  top: 88%;
  left: 32%;
  animation: isShow 1s linear infinite;
  /* z-index: 99; */
}
.hpjmtname {
  width: 14.67%;
  position: absolute;
  top: 91%;
  left: 68%;
  animation: isShow 1s linear infinite;
}

.boat0 {
  width: 12.13%;
  position: absolute;
  top: 17.8%;
  left: 0%;
}
.boat1 {
  width: 12.13%;
  position: absolute;
  top: 23.8%;
  left: 13%;
}
.boat2 {
  width: 12.13%;
  position: absolute;
  /* top: 30.5%;
  left: 35%; */
  top: 28.3%;
  left: 29%;
  /* transform: rotateZ(-18deg); */
  /* opacity: 0; */
}
.boat3 {
  width: 12.13%;
  position: absolute;
  /* top: 37.5%;
  left: 47%; */
  top: 35.5%;
  left: 52%;
  transform: rotateZ(10deg);
}
.boat4 {
  width: 12.13%;
  position: absolute;
  /* top: 49%;
  left: 60%; */
  top: 46%;
  left: 68%;
  transform: rotateZ(20deg);
}
.boat5 {
  width: 12.13%;
  position: absolute;
  top: 58.5%;
  left: 21%;
}
.boat6 {
  width: 12.13%;
  position: absolute;
  top: 63.5%;
  left: 34%;
}
.boat7 {
  width: 12.13%;
  position: absolute;
  top: 69.5%;
  left: 49%;
  transform: rotateZ(20deg);
}
.boat8 {
  width: 12.13%;
  position: absolute;
  top: 75.5%;
  left: 23%;
  /* transform: rotateZ(20deg); */
}
.boat9 {
  width: 12.13%;
  position: absolute;
  top: 83%;
  left: 30%;
  /* transform: rotateZ(20deg); */
}
.boat10 {
  width: 12.13%;
  position: absolute;
  top: 88%;
  left: 28%;
  z-index: 100;
  /* transform: rotateZ(20deg); */
}
.boat11 {
  width: 12.13%;
  position: absolute;
  top: 90.9%;
  left: 55%;
  transform: rotateZ(-50deg);
}

.cover1 {
  width: 22.53%;
  position: absolute;
  top: 30.08%;
  left: 27%;
}
.cover2 {
  width: 9.87%;
  position: absolute;
  top: 37.8%;
  left: 46%;
}
.cover3 {
  width: 12.53%;
  position: absolute;
  top: 53.7%;
  left: 15.5%;
}
.cover4 {
  width: 37.07%;
  position: absolute;
  top: 84.65%;
  left: 0%;
}

@keyframes toRight {
  0% {
    top: -3%;
    opacity: 0;
  }
  100% {
    top: 0.4%;
    opacity: 1;
  }
}

@keyframes toTop {
  0% {
    left: 5%;
    opacity: 0;
  }
  100% {
    left: 25%;
    opacity: 1;
  }
}

@keyframes gjk {
  0% {
    top: 17.8%;
    left: 0%;
  }
  100% {
    top: 20%;
    left: 0%;
  }
}
@keyframes cfdq {
  0% {
    top: 23.8%;
    left: 13%;
  }
  100% {
    top: 25.2%;
    left: 15%;
    /* opacity: 0; */
  }
}
@keyframes yqg {
  0% {
    top: 28.3%;
    left: 29%;
  }
  /* 40% {
    top: 30%;
    left: 34%;
    transform: rotateZ(0deg);
  }
  60% {
    top: 30%;
    left: 35%;
    transform: rotateZ(-18deg);
  }
  100% {
    top: 33%;
    left: 55%;
    transform: rotateZ(5deg);
  } */
  20% {
    top: 30.5%;
    left: 38%;
    transform: rotateZ(-18deg);
  }
  60% {
    top: 32.3%;
    left: 48%;
  }
  100% {
    top: 34.3%;
    left: 52%;
    transform: rotateZ(5deg);
  }
}
@keyframes spdq {
  0% {
    top: 35.5%;
    left: 52%;
  }
  40% {
    top: 37.5%;
    left: 47%;
    /* left: 52%; */
    /* opacity: 0; */
  }
  100% {
    top: 41%;
    left: 55%;
    /* opacity: 1; */
    transform: rotateZ(5deg);
  }
}

@keyframes wsjdq {
  0% {
    top: 46%;
    left: 68%;
  }
  30% {
    top: 49%;
    left: 60%;
  }
  70% {
    top: 53%;
    left: 23%;
  }
  100% {
    top: 54.9%;
    left: 19%;
  }
}

@keyframes shj {
  0% {
    top: 58.5%;
    left: 21%;
  }
  100% {
    top: 63.5%;
    left: 34%;
  }
}

@keyframes stld {
  0% {
    top: 63.5%;
    left: 34%;
  }
  100% {
    top: 68.5%;
    left: 53%;
  }
}
@keyframes jnsx {
  0% {
    top: 69.5%;
    left: 49%;
  }
  100% {
    top: 75.5%;
    left: 23%;
  }
}

@keyframes tcgx {
  0% {
    top: 75.5%;
    left: 23%;
  }
  100% {
    top: 83%;
    left: 30%;
  }
}

@keyframes szh {
  0% {
    top: 83%;
    left: 30%;
  }
  100% {
    top: 88%;
    left: 28%;
  }
}
@keyframes hpjmt {
  0% {
    top: 88%;
    left: 28%;
  }
  50% {
    top: 90%;
    left: 29%;
    transform: rotateZ(0deg);
  }
  70% {
    top: 90.5%;
    left: 32%;
    transform: rotateZ(-50deg);
  }
  100% {
    top: 90.9%;
    left: 55%;
    transform: rotateZ(-50deg);
  }
}

@keyframes twinkle {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes isShow {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes bounceLogo {
  from,
  20%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
  }

  53% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scale3d(1.15, 0.85, 1);
  }

  40%,
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(20px, 0, 0) scale3d(1, 1, 1);
  }

  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(10px, 0, 0) scale3d(1, 1, 1);
  }

  90% {
    transform: translate3d(3px, 0, 0) scale3d(1, 1, 1);
  }
}

/*横屏提示*/

.landscape {
  position: absolute;
  width: 100%;
  background: #000;
  z-index: 999;
  box-sizing: border-box;
}
.landscape .lcx {
  width: 25rem;
  height: 18rem;
  margin-top: 6rem;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}
.landscape .lcx .phoPic {
  position: absolute;
  left: 35%;
  animation-name: rotate;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  transform-origin: center center;
}
.landscape .lcx .word {
  position: absolute;
  bottom: 40%;
  right: 10%;
  text-align: center;
  font-size: 20px;
  color: #ffffff;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(100deg);
  }
}
/* Mobile Landscape Size to Tablet Portrait (devices and browsers) */
@media only screen and (min-width: 480px) and (max-width: 767px) and (orientation: landscape) {
  .landscape {
    display: block;
  }
}
/* Mobile Portrait Size to Mobile Landscape Size (devices and browsers) */
@media only screen and (max-width: 479px) and (orientation: portrait) {
  .landscape {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page1.vue